import { IReducer, IAction, ChannelActionType, DisplayModeActionType, SubscriptionDisplayModeActionType } from 'src/app/store/reducers';
import { Channel } from 'src/app/models/channel';

export interface ListenerCallback {
    (): void;
}

export interface UnsubscribeCallback {
    (): void;
}

export class Store {
    constructor() {
        this._displayModeState = DisplayModeActionType.Today;
        this._subscriptionDisplayModeState = SubscriptionDisplayModeActionType.Grid;
    }

    /* channel state */
    private _channelState: any;
    private _channelListeners: ListenerCallback[] = [];

    initiateChannelState(channelState: Channel) {        
        this._channelState = channelState;
    }

    getChannelState(): Channel {
        return this._channelState;
    }

    subscribeChannelState(listener: ListenerCallback): UnsubscribeCallback {    
        this._channelListeners.push(listener);    

        return () => {
            this._channelListeners = this._channelListeners.filter(l => l !== listener);
        };
    }

    private isChannelStateChanged(newState: Channel): boolean {
        let update: boolean = false;
    
        if (newState) {
          if (!this._channelState)
            update = true;
          else if (this._channelState.Title !== newState.Title)
            update = true;
        }
    
        if (update) this._displayModeState = DisplayModeActionType.Subscription;

        return update;
    }
    /* end of channel state */

    /* display mode state */
    private _displayModeState: any;
    private _displayModeListeners: ListenerCallback[] = [];

    initiateDisplayModeState(displayMode: DisplayModeActionType) {
        this._displayModeState = displayMode;
    }

    getDisplayModeState(): DisplayModeActionType {
        return this._displayModeState;
    }

    subscribeDisplayModeState(listener: ListenerCallback): UnsubscribeCallback {
        this._displayModeListeners.push(listener);

        return () => {
            this._displayModeListeners = this._displayModeListeners.filter(l => l !== listener);
        };
    }

    private isDisplayModeStateChanged(newState: DisplayModeActionType) {
        let update: boolean = false;

        if (newState) {
            if (!this._displayModeState)
                update = true;
            else if (this._displayModeState !== newState)
                update = true;
        }

        if (update) this._channelState = null;
        
        return update;
    }
    /* end of display mode state */

    /* subscription display mode state */
    private _subscriptionDisplayModeState: any;
    private _subscriptionDisplayModeListeners: ListenerCallback[] = [];

    initiateSubscriptionDisplayModeState(subDisplayMode: SubscriptionDisplayModeActionType) {
        this._subscriptionDisplayModeState = subDisplayMode;
    }

    getSubscriptionDisplayModeState(): SubscriptionDisplayModeActionType {
        return this._subscriptionDisplayModeState;
    }

    subscribeSubscriptionDisplayModeState(listener: ListenerCallback): UnsubscribeCallback {
        this._subscriptionDisplayModeListeners.push(listener);

        return () => {
            this._subscriptionDisplayModeListeners = this._subscriptionDisplayModeListeners.filter(l => l !== listener);
        };
    }

    private isSubscriptionDisplayModeStateChanged(newState: SubscriptionDisplayModeActionType) {
        let update: boolean = false;

        if (newState) {
            if (!this._subscriptionDisplayModeState)
                update = true;
            else if (this._subscriptionDisplayModeState !== newState)
                update = true;
        }

        return update;
    }
    /* end of subscription display mode state */

    /*
    dispatch takes current state and action then, process and return a resulting state
    */
    dispatch(reducer: IReducer<Channel>, action: IAction): void;
    dispatch(reducer: IReducer<DisplayModeActionType>, action: IAction): void;
    dispatch(reducer: IReducer<SubscriptionDisplayModeActionType>, action: IAction): void;
    dispatch(reducer: any, action: IAction): void {        
        if (action.type in ChannelActionType) {               
            let newState: any = reducer(this._channelState, action);

            if (this.isChannelStateChanged(newState)) {
                this._channelState = newState;
                this._channelListeners.forEach((listener: ListenerCallback) => listener());
            }
        }
        else if (action.type in DisplayModeActionType) {
            let newState: any = reducer(this._displayModeState, action);

            if (this.isDisplayModeStateChanged(newState)) {
                this._displayModeState = newState;
                this._displayModeListeners.forEach((listener: ListenerCallback) => listener());
            }                     
        }
        else if (action.type in SubscriptionDisplayModeActionType) {
            let newState: any = reducer(this._subscriptionDisplayModeState, action);

            if (this.isSubscriptionDisplayModeStateChanged(newState)) {
                this._subscriptionDisplayModeState = newState;
                this._subscriptionDisplayModeListeners.forEach((listener: ListenerCallback) => listener());
            }
        }
    }    
}